import React, { useContext, memo } from 'react';
import { TabContext } from './Tabs';

interface TabPanelProps {
  index: number;
  children: React.ReactNode;
}

const TabPanel: React.FC<TabPanelProps> = memo(({ index, children }) => {
  const context = useContext(TabContext);

  if (!context) {
    throw new Error('TabPanel must be used within a Tabs component.');
  }

  const { activeIndex } = context;

  return activeIndex === index ? (
    <div className="flex-grow">
      <div
        id="tab-panel"
        className="h-full overflow-hidden rounded-xl bg-neutral-200"
      >
        {children}
      </div>
    </div>
  ) : null;
});

export default TabPanel;
